import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import Lottie from 'lottie-react-web';

// Model //
import FetchModule from '../../../Model/Network/FetchModule';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
import RefundReasonInput from '../Component/RefundReasonInput';
// Animation //


export default function DeleteModal(props) {
  const { data, onClickExit } = props;

  const [reason, setReason] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('내역 삭제 진행중');

  const navigate = useNavigate();

  // 스크롤 정지 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // 이전 환불 신청이 있는지 확인 및 세팅 //
  useEffect(() => {
    setTotalPrice(data.totalPrice);
  }, [data])

  // 로딩 텍스트 변경 //
  useEffect(() => {
    if (!isLoading) return;

    setTimeout(() => {
      if (loadingText === '내역 삭제 진행중') setLoadingText('내역 삭제 진행중.');
      else if (loadingText === '내역 삭제 진행중.') setLoadingText('내역 삭제 진행중..');
      else if (loadingText === '내역 삭제 진행중..') setLoadingText('내역 삭제 진행중...');
      else if (loadingText === '내역 삭제 진행중...') setLoadingText('내역 삭제 진행중');
    }, 800);
  }, [isLoading, loadingText])


  // 환불버튼 클릭시 //
  function onClickRefund() {
    if (isLoading) return;

    let requestData = {
      merchantUid: data.merchantUid,
      reason: '관리자의 내역삭제 요청',
    }

    setIsLoading(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('sales/delete', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          alert('삭제를 완료했습니다');
          navigate(-1);
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  


  return (
    <TopLevelWrapper>
      {
        isLoading ?
          <ViewWrapper>
            <LottieWrapper>
              <Lottie options={{ animationData: LoadingAnimation }} />
            </LottieWrapper>
            <LoadingTextWrapper>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>{loadingText}</Text>
            </LoadingTextWrapper>
          </ViewWrapper>
          :
          <ModalTotalWrapper>
            <ModalView>
              <TitleWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>신청권 삭제</Text>
              </TitleWrapper>
              <ExplanationWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>해당 회원님의 참가신청 내역이 모두 삭제되며</Text>
                <RefundNoticeTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>결제내역은</Text>
                  <Text style={{ margin: '0px 4px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FF3131' cursor='default'>전액 환불</Text>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>처리됩니다</Text>
                </RefundNoticeTextWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>계속 진행하시겠습니까?</Text>
              </ExplanationWrapper>
              <ButtonWrapper>
                <ExitButton onClick={onClickExit}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>취소</Text>
                </ExitButton>
                <DeleteButton onClick={onClickRefund}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>삭제하기</Text>
                </DeleteButton>
              </ButtonWrapper>
            </ModalView>
          </ModalTotalWrapper>
      }
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;
  
  width: 100vw;
  height: 100vh;

  overflow-y: scroll;

  background-color: rgba(0, 0, 0, 0.2);
  
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalTotalWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 15px 10px 15px;

  width: 299px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #2F2F32;

  overflow: hidden;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;

  gap: 4px;
`;

const ReasonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  gap: 8px;
`;

const RefundNoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 10px;

  width: 100%;

  gap: 10px;
`;

const RefundNoticeTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #17171B;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #FF0000;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 40px;

  width: 180px;
  height: 240px;

  overflow: hidden;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const LoadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 140px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;